type ScreenWrapperProps = {
	children: React.ReactNode;
};
const ScreenBody = ({ children }: ScreenWrapperProps) => {
	return <main>{children}</main>;
};

export { ScreenBody };
